<script>
  import { addEllipses, getAfterTimeStampStrapi } from '../../../utils'
  import { link } from 'svelte-spa-router'

  export let projectID
  export let projectName = ''
  export let saleAddress = ''
  export let startTime = ''
  export let endTime = ''
  export let status = ''
  export let saleType;
  export let draft;

  saleType = saleType ? saleType.replaceAll('_',' ') : "Fixed Raise";

  const copyCode = () => {
    navigator.clipboard.writeText(saleAddress)
  }
</script>

<tr>
  <td>{projectName}</td>

  <td>
    {#if saleAddress}
      {addEllipses(saleAddress)}
      <img
        class="copy-sale"
        on:click={copyCode}
        src="./images/copy.svg"
        alt="copy" />
    {:else}-{/if}
  </td>
  <td>
    {#if startTime}
      {getAfterTimeStampStrapi(new Date(startTime).getTime(), 'MM-DD-YYYY HH:mm')}
    {:else}-{/if}
  </td>
  <td>
    {#if endTime}
      {getAfterTimeStampStrapi(new Date(endTime).getTime(), 'MM-DD-YYYY HH:mm')}
    {:else}-{/if}

  </td>
  <td>
    <span>
      {saleType}
    </span>
  </td>
  <td>
    <span class={`table-status ${status.replaceAll(' ', '').toLowerCase()}`}>
      {status}
    </span>
  </td>
  
  <td>
    {#if !draft}
      <div class="table-drop flex">
        <a id="preview-{projectID}"
          title="Preview"
          href={`/project-details/${projectID}/${saleAddress}`}
          use:link>
          <img
            class="table-drop-down"
            src="./images/preview.svg"
            alt="preview" />
        </a>
        <a id="sales-{projectID}"
          title="Sales"
          href={`#/sale-detail/${projectID}/${saleAddress}`}
          use:link
          on:click>
          <img class="table-drop-down" src="./images/sale.svg" alt="sale" />
        </a>
      </div>
    {:else}
      <div class="table-drop flex">
        <a id="edit-{projectID}"
          title="Edit"
          href={`#/permissionless/${projectID}`}
          use:link
          on:click>
          <img
            class="table-drop-down"
            src="./images/edit.svg"
            alt="edit"
            on:click />
        </a>
      </div>
    {/if}
  </td>
</tr>
